import { apiFetch, v1Path } from './api';

/** An org-wide tag. Any work item in any stream can carry it. */
export type TagDto = { id: string; name: string; color: string; count: number };

export const TAGS_CHANGED_EVENT = 'bb:tags-changed';

export function fetchTags(): Promise<TagDto[]> {
  return apiFetch<{ items: TagDto[] }>(v1Path('/tags')).then((res) => res.items);
}

/** Returns the existing tag when the name is already taken, ignoring case. */
export function createTag(name: string): Promise<TagDto> {
  return apiFetch<TagDto>(v1Path('/tags'), { method: 'POST', body: JSON.stringify({ name }) });
}

export async function setWorkItemTags(workItemId: string, tagIds: string[]): Promise<string[]> {
  const res = await apiFetch<{ work_item_id: string; tag_ids: string[] }>(v1Path(`/work-items/${workItemId}/tags`), {
    method: 'PUT',
    body: JSON.stringify({ tag_ids: tagIds }),
  });
  window.dispatchEvent(new CustomEvent(TAGS_CHANGED_EVENT));
  return res.tag_ids;
}

/** Tags whose name contains the query, plus whether the exact name already exists. */
export function matchTags(tags: TagDto[], query: string): { matches: TagDto[]; exact: boolean } {
  const needle = query.trim().toLowerCase();
  if (!needle) return { matches: tags, exact: false };
  return {
    matches: tags.filter((tag) => tag.name.toLowerCase().includes(needle)),
    exact: tags.some((tag) => tag.name.toLowerCase() === needle),
  };
}
